import { Component, OnDestroy, OnInit } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { LivePersonService } from './core/services/live-person/live-person.service';
import { AdobeAnalyticsService } from './core/services/adobe-analytics/adobe-analytics.service';
import { filter, Subject, takeUntil } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { TestKeyContainerDirective } from './core/directives/test-key.directive';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  standalone: true,
  imports: [IonApp, IonRouterOutlet, TestKeyContainerDirective],
})
export class AppComponent implements OnInit, OnDestroy {

  protected readonly _destroyed: Subject<void> = new Subject<void>();
  
  constructor(private livePersonSvc: LivePersonService, 
    private adobeSvc: AdobeAnalyticsService,
    private router: Router) {}  
  
  ngOnInit(): void {
    //load livePerson and adobe analytics. TODO: create and add to applicaiton initialization
    this.livePersonSvc.loadLivePersonScript();
    this.adobeSvc.loadAdobeAnalytics();
  }

  ngOnDestroy(): void {
    this._destroyed.next();
    this._destroyed.complete();
  }
}
